import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import api from '@/api';
import {
  retryUnlessNotInYourVersion,
  yourVersionCourseSlug,
} from '@/api/errors';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export const Route = createFileRoute('/_app/_course/quizzes/$quizSlug')({
  component: QuizSlugRedirect,
});

function QuizSlugRedirect() {
  const { quizSlug } = Route.useParams();
  const { me } = useCurrentUser();
  const navigate = useNavigate();
  const language = me?.language ?? 'EN';

  const { data: resolved, error } = api.quizBySlug.useQuery(
    { path: { slug: quizSlug }, query: { language } },
    { retry: retryUnlessNotInYourVersion },
  );

  // An old link: the viewer's version of the course has no such quiz.
  const versionCourseSlug = yourVersionCourseSlug(error);

  useEffect(() => {
    if (versionCourseSlug) {
      navigate({
        to: '/courses/$courseSlug/',
        params: { courseSlug: versionCourseSlug },
        replace: true,
      });
      return;
    }
    if (!resolved) return;
    // A topic quiz renders inline on its topic page, as in legacy, so a
    // topic-scoped quiz URL goes there rather than to the lesson's final quiz.
    if (resolved.topic_slug) {
      navigate({
        to: '/topic/$topicSlug/',
        params: { topicSlug: resolved.topic_slug },
        replace: true,
      });
      return;
    }
    navigate({
      to: '/lessons/$lessonSlug/quiz/',
      params: { lessonSlug: resolved.lesson_slug },
      replace: true,
    });
  }, [resolved, versionCourseSlug, navigate]);

  return null;
}
